import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageVendorStore } from "./localStorageStore";
import { createSupabaseVendorStore } from "./supabaseStore";
import type { VendorStore } from "./types";

// Same dispatch pattern as the other stores: fall back to localStorage when
// Supabase isn't configured OR when the E2E bypass flag is set. Playwright
// runs with VITE_E2E_BYPASS_AUTH=true.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const vendorStore: VendorStore = useLocal
  ? createLocalStorageVendorStore()
  : createSupabaseVendorStore();

export type { Vendor, VendorStore, VendorType, NewVendorInput } from "./types";
